import {SvgIcon, useTheme} from '@mui/material';

export default function LocationOn() {
	const theme = useTheme();
	// @ts-ignore
	const color = theme.palette.mode === 'light' ? theme.palette.primary[800] : theme.palette.primary.main;
	return (
		<svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g filter="url(#filter0_d_3081_6264)">
				<rect x="12" y="8" width="44" height="44" rx="22" fill="white" shape-rendering="crispEdges"/>
				<path
					d="M34 38.25C29.45 38.25 25.75 34.55 25.75 30C25.75 25.45 29.45 21.75 34 21.75C38.55 21.75 42.25 25.45 42.25 30C42.25 34.55 38.55 38.25 34 38.25ZM34 23.25C30.28 23.25 27.25 26.28 27.25 30C27.25 33.72 30.28 36.75 34 36.75C37.72 36.75 40.75 33.72 40.75 30C40.75 26.28 37.72 23.25 34 23.25Z"
					fill="#00174C"/>
				<path
					d="M34 33.75C31.93 33.75 30.25 32.07 30.25 30C30.25 27.93 31.93 26.25 34 26.25C36.07 26.25 37.75 27.93 37.75 30C37.75 32.07 36.07 33.75 34 33.75ZM34 27.75C32.76 27.75 31.75 28.76 31.75 30C31.75 31.24 32.76 32.25 34 32.25C35.24 32.25 36.25 31.24 36.25 30C36.25 28.76 35.24 27.75 34 27.75Z"
					fill="#00174C"/>
				<path
					d="M34 22.75C33.59 22.75 33.25 22.41 33.25 22V20C33.25 19.59 33.59 19.25 34 19.25C34.41 19.25 34.75 19.59 34.75 20V22C34.75 22.41 34.41 22.75 34 22.75Z"
					fill="#00174C"/>
				<path
					d="M26 30.75H24C23.59 30.75 23.25 30.41 23.25 30C23.25 29.59 23.59 29.25 24 29.25H26C26.41 29.25 26.75 29.59 26.75 30C26.75 30.41 26.41 30.75 26 30.75Z"
					fill="#00174C"/>
				<path
					d="M34 40.75C33.59 40.75 33.25 40.41 33.25 40V38C33.25 37.59 33.59 37.25 34 37.25C34.41 37.25 34.75 37.59 34.75 38V40C34.75 40.41 34.41 40.75 34 40.75Z"
					fill="#00174C"/>
				<path
					d="M44 30.75H42C41.59 30.75 41.25 30.41 41.25 30C41.25 29.59 41.59 29.25 42 29.25H44C44.41 29.25 44.75 29.59 44.75 30C44.75 30.41 44.41 30.75 44 30.75Z"
					fill="#00174C"/>
			</g>
			<defs>
				<filter id="filter0_d_3081_6264" x="0" y="0" width="68" height="68" filterUnits="userSpaceOnUse"
				        color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix"/>
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					               result="hardAlpha"/>
					<feOffset dy="4"/>
					<feGaussianBlur stdDeviation="6"/>
					<feComposite in2="hardAlpha" operator="out"/>
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.160784 0 0 0 0 0.478431 0 0 0 0.1 0"/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3081_6264"/>
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3081_6264" result="shape"/>
				</filter>
			</defs>
		</svg>
	);
}
